"use strict";

var isValue = require("./is-value");

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/valid-value.js
// module id = 111
// module chunks = 0